var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
var initialState = {
    id: 0,
};
export default function projectReducer(state, actions) {
    if (state === void 0) { state = initialState; }
    var type = actions.type, payload = actions.payload;
    switch (type) {
        case types.SET_PROJECT_ID:
            return __assign(__assign({}, state), { id: payload });
        default:
            return state;
    }
}
